import { Vec3 } from 'vec3';
export declare const player: (player: Player, serv: Server, { version }: Options) => void;
export declare const entity: (entity: Entity, serv: Server) => void;
export declare const server: (serv: Server, { version }: Options) => void;
declare global {
    interface Player {
        /** handle `command` */
        "handleCommand": (str: string) => Promise<void>;
    }
    interface Entity {
    }
    interface Server {
        /** Returns an array of entities that satisfies the given command selector string `str`, execution position `pos`, execution world `world`, and the ID of the entity that initiated the execution `ctxEntityId`.
         *
         * Valid selector string values are names of online players and [valid target selector variables](https://minecraft.fandom.com/wiki/Target_selectors#Target_selector_variables).
         *
         * Setting `allowUser` to `true` (default value) enables players to be included in the returned array, disables otherwise.
         */
        'selectorString': (str: string, pos?: Vec3, world?: any, allowUser?: boolean | undefined, ctxEntityId?: any) => Entity[];
    }
}
